import AuthView from "./auth";
import ValidateView from "./otp";
import { $fetcher } from "../../../../../charge";
import Supports from "../../../../../utils/supports";
import ViewFactory from "../../../helpers/viewfactory";
import { isJsonResponse } from "../../../../../fetcher/utils";
import { falseFunction } from "../../../../../collections/helpers";
import { getValueAtPath, isPlainObject, isString } from "../../../../../utils";
import ErrorState from "../../../../common/error";
import RegisterMobileView from "./registermobile";

function __generateRandomOTP__() {
  return String(Math.random() * 1e5)
    .split('')
    .reverse()
    .join('')
    .replace(/^\d+(?=\d{6})|\.\d+$/g, '');
}

export function chargeCard(retry_charge) {
  const $this = this;
  const { $charge, $inputs } = this;
  const { auth, suggested_auth = null } = isPlainObject($this.authModel) ? $this.authModel : {};

  let data = {};

  if (auth === 'PIN') {
    const pin = getValueAtPath($inputs, '[pin].value');

    if (pin && /^\d{4}$/.test(pin)) {
      data = { ...data, pin, suggested_auth }
    } else return;
  }

  if (auth === 'AVS') {
    const billingaddress = getValueAtPath($inputs, '[billing_address].value');
    const billingcity = getValueAtPath($inputs, '[billing_city].value');
    const billingcountry = getValueAtPath($inputs, '[billing_country].value.sortname');
    const billingstate = getValueAtPath($inputs, '[billing_state].value');
    const billingzip = getValueAtPath($inputs, '[billing_zip].value');
    const cardholdername = getValueAtPath($inputs, '[card_holder_name].value') || null;
    const phonenumber = getValueAtPath($inputs, '[phonenumber].value') || null;
    
    if (billingaddress && billingcity && billingcountry && billingstate && billingzip && cardholdername && phonenumber) {
      data = { ...data, billingaddress, billingcity, billingcountry, billingstate, billingzip, cardholdername, phonenumber, suggested_auth: 'AVS_NOAUTH' }
    } else return;
  }

  const expiry = getValueAtPath($inputs, '[expiry].value');
  const cvv = getValueAtPath($inputs, '[cvv].value') || null;
  const cardno = getValueAtPath($inputs, '[card_number].value') || null;

  const [expirymonth = null, expiryyear = null] = isString(expiry)
    ? expiry.trim().split(/\s*\/\s*/)
    : String();

  if (cardno && cvv && expirymonth && expiryyear) {
    data = { ...data, cardno, cvv, expirymonth, expiryyear };
    const remember_device = getValueAtPath($inputs, '[remember_card].value') === true;

    // if (
    //   cardno.length <= 16 &&
    //   ["51", "52", "53", "54", "55"].indexOf(cardno.substring(0, 2)) !== -1
    // ) {
    //     data["3DS_OVERRIDE"] = 1;
    // }

    if (retry_charge) {
      data = { ...data, retry_charge };
    }

    if (remember_device) {
      const remember_device_email = getValueAtPath($inputs, '[remember_email].value') || null;
      const remember_device_mobile_key = getValueAtPath($inputs, '[remember_phone].value') || null;

      if (remember_device_email && remember_device_mobile_key) {
        if (Supports.localStorage && remember_device_mobile_key) {
          localStorage.setItem('device_mobile_key', remember_device_mobile_key);
        }
        
        data = { ...data, remember_device, remember_device_email, remember_device_mobile_key };
      } else { data = null }
    }

    const resetInput = () => setTimeout(() =>  {
      $this.authModel = null;
      $inputs.$reset();
    },0);

    if (data) {
      // const currentCanResendOTP = Boolean($this.CAN_RESEND_OTP);

      const restoreCanResendOTP = () => setTimeout(() => {
        // $this.CAN_RESEND_OTP = currentCanResendOTP;
        // $inputs.$reset();
        view && view.activate.call($this);
      }, 0);

      $this.CAN_RESEND_OTP = false;

      $charge.init({
        data,
        onError: restoreCanResendOTP,
        onFailed: restoreCanResendOTP,
        onChargeFailed: resetInput,
        onRequireSuggestedAuth() {
          const { auth, suggested_auth } = isPlainObject(this) ? this : {};
          $this.authModel = { auth, suggested_auth };
          AuthView && AuthView.activate();
        },
        onRequireValidation() {
          const { data } = isPlainObject(this) ? this : {};
          const chargeResponseMessage = getValueAtPath(data, 'chargeResponseMessage')

          if (chargeResponseMessage.includes('Kindly enter the mobile no registered with your bank')) {
            $this.COLLECT_MOBILE_INSTRUCTIONS = chargeResponseMessage;
            RegisterMobileView && RegisterMobileView.activate();
          } else {
            $this.SHOULD_VALIDATE_CHARGE = false;
            $this.SHOULD_VALIDATE_CHARGE = true;
          }
        }
      });
    }
  }
}

export function chargeSavedCard() {
  const $this = this;
  const { DATA, $charge, $inputs, dispatch, useOldSavedCardFlow, startResendTimer } = this;
  const savedCard = getValueAtPath($inputs, '[saved_card].value');

  if (isPlainObject(savedCard)) {
    const card_hash = savedCard.hash;
    const device_key = getValueAtPath(this.$savedCards, 'device.phone');

    if (useOldSavedCardFlow) {
      ValidateView && ValidateView.activate(() => {
        dispatch(ErrorState.actions.updateErrorMessage());
        $inputs.$reset("otp");

        $fetcher(new URL('/v2/gpx/users/send_otp', process.env.API_BASE_URL), {
          body: JSON.stringify({
            card_hash,
            device_key,
            public_key: getValueAtPath(DATA, 'PBFPubKey'),
            modalauditid: getValueAtPath(DATA, 'modalauditid')
          })
        })
          .then(response => {
            if (isJsonResponse(response) && response.ok) {
              return response.json()
                .then(response => {
                  const { message, status } = isPlainObject(response) ? response : {};
                  return status === 'success' && message === 'OTP-SENT' && (startResendTimer(), true);
                })
            }
          })
          .catch(falseFunction);
      });
    }
    
    else {
      $charge.init({
        data: {
          card_hash,
          device_key,
          is_visa: savedCard.brand === 'VISA',
          is_saved_card_charge: true,
          include_card_country: true,
          payment_type: 'saved-card',
          otp: __generateRandomOTP__()
        }
      });
    }
  }
}

export default function view() {
  const $this = this;
  const removeCardType = () => $this.resetCardType();

  return (view = ViewFactory({
    NAME: 'CARD_INIT_VIEW',
    inputs: [
      'card_number::cardnumber',
      'expiry',
      'cvv',
      'remember_card::remember',
      'remember_phone::rememberPhone',
      'remember_email::rememberEmail',
      'saved_card::savedcard'
    ],
    constants: {
      removeSavedCard(card) {
        return ($this.SAVED_CARDS_ACTIVE && $this.SAVED_CARDS_AVAILABLE)
          ? $this.$savedCards.remove(card)
          : Promise.resolve(false);
      },
      removeCardType
    },
    mutables: { hasSavedCard: 'SAVED_CARDS_AVAILABLE', useSavedCard: 'SAVED_CARDS_ACTIVE', $cards: 'SAVED_CARDS', cardType: 'CARD_TYPE' },
    next() {
      return ($this.SAVED_CARDS_ACTIVE ? chargeSavedCard : chargeCard).call($this);
    },
    switch() {
      $this.SAVED_CARDS_ACTIVE = $this.SAVED_CARDS_AVAILABLE
        ? !$this.SAVED_CARDS_ACTIVE
        : false;
    }
  }).call(this));
}
